export const localStorageEffect = (key: string) => ({ setSelf, onSet }: any) => {
    const savedValue = localStorage.getItem(key)
    if (savedValue && savedValue != 'undefined') {
        setSelf(JSON.parse(savedValue));
    }
  
    onSet((newValue: any, _: any, isReset: boolean) => {
        isReset || newValue === undefined
            ? localStorage.removeItem(key)
            : localStorage.setItem(key, JSON.stringify(newValue));
    });
};